module.exports = __webpack_public_path__ + "img/50.abd07d78.jpg";